import React from 'react';

function BecomeAStringer() {
  return <></>;
}

export default BecomeAStringer;
